import DOMPurify from "dompurify";


export const sanitizedMsg = (msg) => ({
    __html: DOMPurify.sanitize(msg)
});

export const transformHashtags = (html) => {
    const hashtagRegex = /#(\w+)/g;
    return html.replace(hashtagRegex, '<span class="hashtag">#$1</span>');
};

export const extractFirstWordsWithoutImages = (corps, numberOfWords) => {

    if (corps) {
        let cleanedHtmlContent = JSON?.parse(corps?.replace(/<img[^>]*>/g, ''))

        let parser = new DOMParser()
        let doc = parser?.parseFromString(cleanedHtmlContent, 'text/html')

        let textContent = doc?.body?.textContent || ""
        let words = textContent?.split(/\s+/)
        return words?.slice(0, numberOfWords ?? 60).join(' ')
    } else {
        return ("<p>Pas de corps à cet article</p>")
    }
}

/**
 * Permet de contrôler du contenu JSX sous forme d'objet généré dans l'app React
 * @param element
 * @returns {boolean|*|boolean}
 */
export const containsTextOrImage = (element) => {
    if (!element || typeof element !== 'object') return false;

    if (element.type === 'img') return true;

    if (element.type === 'p' || (element.props && element.props.dangerouslySetInnerHTML)) return true;

    if (Array.isArray(element.props?.children)) {
        return element.props.children.some(containsTextOrImage);
    }

    if (element.props?.children) {
        return containsTextOrImage(element.props.children);
    }

    return false;
}